import axios from 'axios';
axios.defaults.baseURL="https://seasenseresearch.com/backend/";
 axios.defaults.baseURLImage="https://seasenseresearch.com/backend";
//axios.defaults.baseURL="https://seasenseopc.seataxi.in/backend/";
 // axios.defaults.baseURL="http://localhost:8080/backend/";
// axios.defaults.baseURLImage="http://localhost:8080/backend";
const CONTACT_API_URL ="add_contactus";
const REGISTER_URL_LOGIN ="Login";
const VIEW_URL_VIEW_DETAILS ="View_details";                                 
const DELETE_DETAIL_API_URL ="contact_delete";
const UPDATE_PASSWORD_URL ="update_password";
const CAREERS_DETAILS_API_URL ="careers_details";
const VIEW_CAREERS_URL_VIEW_DETAILS ="View_career_details";
const DELETE_CAREER_DETAILS_API_URL ="view_careers_delete";
const UPDATE_CAREER_DETAILS_API_URL ="update_career_details";
const VIEW_CAREERS_SINGLE_URL_VIEW_DETAILS = "single_details";
const UPDATE_READED_API_URL ="update_read_status";
const REVIEW_DETAILS_API_URL ="add_review";
const DELETE_REVIEW_DETAILS_API_URL ="add_review_delete";
const VIEW_REVIEW_URL_VIEW_DETAILS ="View_review_details";
const UPDATE_REVIEW_DETAILS_API_URL ="update_review_details";
const BANK_DETAILS_API_URL ="bank_details";
const VIEW_BANK_URL_VIEW_DETAILS ="View_bank_details";
const DELETE_BANK_DETAILS_API_URL ="view_bank_delete";
const UPDATE_BANK_DETAILS_API_URL ="update_bank_details";
const IMAGE_UPLOAD_QR_API_URL ="qr_image";
const VIEW_URL_QR_IMAGES ="view_qr_images";
const DELETE_QR_IMAGE_API_URL ="qr_image_delete";
const Payment_Gateway_URL ="initiate-payment";
const UPDATE_CONTACT_MESSAGE_API_URL ="update_rewrite";

export const ContactusApi= async (data)=>{
    try {
        const response = await axios.post(CONTACT_API_URL, data);
        return response.data; 
      } catch (error) {
        throw error;
      }
  }

  export const SignInApi= async (data)=>{
    // axios.post(REGISTER_URL, {data:user})
    try {
        const response = await axios.post(REGISTER_URL_LOGIN, data);
        return response.data; 
      } catch (error) {
        throw error;
      }
  }
  

  export const ViewDetailsApi = async () => {
    try {
      const response = await axios.get(VIEW_URL_VIEW_DETAILS);
      return response.data;
    } catch (error) {
      throw error;
    }
  };




  export const deleteDetailApi = async (detailId) => {
    console.log("Detail ID: " + detailId); 
    try {
      const response = await axios.delete(`${DELETE_DETAIL_API_URL}/${detailId}`, {     
      });
      console.log('Delete detail response:', response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  


  
  export const updateConfirmPassword = async (data) => {
    try {
      const response = await axios.post(UPDATE_PASSWORD_URL, data, {    
      });
      console.log('data',response);
      return response.data; 
    } catch (error) {
      throw error;   
    }
  };


  export const CareerDetailsApi = async (data) => {
    try {
      const response = await axios.post(CAREERS_DETAILS_API_URL, data); 
      return response.data; 
    } catch (error) {
      throw error; 
    }
  };
  

  export const ViewCareerDetailsApi = async () => {
    try {
      const response = await axios.get(VIEW_CAREERS_URL_VIEW_DETAILS);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  

  export const ViewCareerDetailsSingleApi = async (id) => {
    try {
      const response = await axios.get(`${VIEW_CAREERS_SINGLE_URL_VIEW_DETAILS}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  
  export const deleteCareerDetailsApi = async (careerId) => {
    console.log("Career ID: " + careerId);
  
    try {
      const response = await axios.delete(`${DELETE_CAREER_DETAILS_API_URL}/${careerId}`);
      console.log('Delete career details response:', response.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting career details:", error);
      throw error;
    }
  };
  
  export const updateCareerDetailsApi = async (careerId, updatedData) => {
    console.log("Updating Career ID: " + careerId);
  
    try {
      const response = await axios.put(`${UPDATE_CAREER_DETAILS_API_URL}/${careerId}`, updatedData);
      console.log("Update career details response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating career details:", error);
      throw error;
    }
  };


  export const updateReadStatusApi = async (id, newStatus) => {
    console.log("Updating Read Status for ID:", id);
  
    try {
      const response = await axios.put(`${UPDATE_READED_API_URL}/${id}`, {
        readed: newStatus, // You can include the desired status change here
      });
      console.log("Update read status response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating read status:", error);
      throw error;
    }
  };



  export const ReviewStatusApi = async (data) => {
    try {
      const response = await axios.post(REVIEW_DETAILS_API_URL, data); 
      return response.data; 
    } catch (error) {
      throw error; 
    }
  };


  export const deleteReviewDetailsApi = async (careerId) => {
    console.log("Career ID: " + careerId);
  
    try {
      const response = await axios.delete(`${DELETE_REVIEW_DETAILS_API_URL}/${careerId}`);
      console.log('Delete career details response:', response.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting career details:", error);
      throw error;
    }
  };


  
  export const ViewReviewDetailsApi = async () => {
    try {
      const response = await axios.get(VIEW_REVIEW_URL_VIEW_DETAILS);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  export const updateReviewDetailsApi = async (careerId, updatedData) => {
    console.log("Updating Career ID: " + careerId);
  
    try {
      const response = await axios.put(`${UPDATE_REVIEW_DETAILS_API_URL}/${careerId}`, updatedData);
      console.log("Update career details response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating career details:", error);
      throw error;
    }
  };


  export const BankDetailsApi = async (data) => {
    try {
      const response = await axios.post(BANK_DETAILS_API_URL, data); 
      return response.data; 
    } catch (error) {
      throw error; 
    }
  };


  export const ViewBankDetailsApi = async () => {
    try {
      const response = await axios.get(VIEW_BANK_URL_VIEW_DETAILS);
      return response.data;
    } catch (error) {
      throw error;
    }
  };



  export const deleteBankDetailsApi = async (careerId) => {
  
    try {
      const response = await axios.delete(`${DELETE_BANK_DETAILS_API_URL}/${careerId}`);
      console.log('Delete bank details response:', response.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting bank details:", error);
      throw error;
    }
  };

  
  export const updateBankDetailsApi = async (careerId, updatedData) => {

  
    try {
      const response = await axios.put(`${UPDATE_BANK_DETAILS_API_URL}/${careerId}`, updatedData);
      console.log("Update bank details response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating bank details:", error);
      throw error;
    }
  };


  export const QrImageApi = async (formData) => {
    try {
      const response = await axios.post(IMAGE_UPLOAD_QR_API_URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      return response.data; 
    } catch (error) {
      throw error;
    }
  }

    
  export const ViewQrImagesApi = async () => {
    try {
      const response = await axios.get(VIEW_URL_QR_IMAGES);
      return response.data; // Return the data from the response
    } catch (error) {
      console.error('Error fetching images:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  };


  export const deleteQrImageApi = async (qrImageId) => {

    console.log("Qr Image ID: " + qrImageId);

    try {
        const response = await axios.delete(`${DELETE_QR_IMAGE_API_URL}/${qrImageId}`);
        
        console.log('Delete QR image response:', response.data);
        return response.data;
    } catch (error) {
        console.error("Error deleting QR image:", error);
        throw error;
    }
};



export const PaymentGatewayApi= async (data)=>{
  try {
    const response = await axios.post(Payment_Gateway_URL, data, {
      headers: { 'Content-Type': 'application/json' },
      responseType: 'text' // 👈 tells axios not to parse the response
    });
    return response.data; // this will be the raw HTML string
  } catch (error) {
    throw error;
  }
}




export const updateContactMessageApi = async (id, rewrite) => {
  try {
    const response = await axios.put(`${UPDATE_CONTACT_MESSAGE_API_URL}/${id}`, { rewrite });
    return response.data; // Should return { status: true, message: "Message updated successfully" }
  } catch (error) {
    console.error("Error updating contact rewrite:", error);
    return null;
  }
};





